<template>
  <div>
    <v-layout
      v-if="loading"
      justify-center
      align-center
      class="loading-indicator"
    >
      <v-progress-circular
        indeterminate
        :size="70"
        :width="7"
      />
    </v-layout>
    <customer-edit
      v-else-if="editingCustomer"
      :customer-data="customerData"
      @close="editingCustomer=false"
      @edited="edited"
      @error="editingCustomer=false"
    />

    <v-card
      v-show="!editingCustomer && !firstLoading"
      class="customers-card"
    >
      <v-btn
        fab
        color="primary"
        @click="add"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :search="search"
        :server-items-length="serverItemsLength"
        fixed-header
        dense
        no-data-text="Нет данных для отображения"
        :footer-props="{
          itemsPerPageText: 'Число заданий на странице',
          itemsPerPageOptions: [25, 50]
        }"
      >
        <tr
          slot="item"
          slot-scope="props"
        >
          <td>{{ props.item.customer_number }}</td>
          <td>{{ customerTypes[props.item.customer_type] }}</td>
          <td>{{ props.item.company_full_name }}</td>
          <td>{{ props.item.last_name }}</td>
          <td>{{ props.item.first_name }}</td>
          <td>{{ props.item.middle_name }}</td>
          <td class="justify-center px-0">
            <span class="action-btns">
              <v-btn
                icon
                class="mt-1"
                title="Редактировать"
                @click="edit(props.item)"
              >
                <v-icon color="teal">
                  edit
                </v-icon>
              </v-btn>
              <v-btn
                icon
                class="mt-1"
                title="Удалить"
                @click="deleteItem(props.item)"
              >
                <v-icon color="pink">
                  delete
                </v-icon>
              </v-btn>
            </span>
          </td>
        </tr>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import CustomerEdit from './CustomerEdit'
const API_URL = 'customers'
export default {
  name: 'Customers',
  components: {
    CustomerEdit
  },
  data () {
    return {
      search: '',
      serverItemsLength: 0,
      items: [],
      customerData: {},
      firstLoading: true,
      loading: true,
      options: { page: 1, itemsPerPage: 25 },
      getTimer: '',
      editingCustomer: false,
      customerTypes: {
        1: 'Физическое лицо',
        2: 'Индивидуальный предприниматель',
        3: 'Юридическое лицо'
      },
      headers: [
        {
          text: 'Лицевой счёт',
          align: 'left',
          sortable: false,
          value: 'customer_number'
        },
        {
          text: 'Тип лицевого счёта',
          align: 'left',
          sortable: false,
          value: 'customer_type'
        },
        {
          text: 'Наименование',
          align: 'left',
          sortable: false,
          value: 'company_full_name'
        },
        {
          text: 'Фамилия',
          align: 'left',
          sortable: false,
          value: 'last_name'
        },
        {
          text: 'Имя',
          align: 'left',
          sortable: false,
          value: 'first_name'
        },
        {
          text: 'Отчество',
          align: 'left',
          sortable: false,
          value: 'middle_name'
        },
        { text: '', sortable: false, value: '' }
      ]
    }
  },
  watch: {
    options: {
      handler () {
        this.getItemsApiTimer()
      },
      deep: true
    }
  },
  methods: {
    getItemsApi () {
      this.loading = true
      this.axios.get(`/api/${API_URL}/?per_page=${this.options.itemsPerPage}&page=${this.options.page}`)
        .then((response) => {
          this.items = response.data.results
          this.serverItemsLength = response.data.count
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.firstLoading = false
          this.loading = false
        })
    },
    getItemsApiTimer () {
      clearTimeout(this.getTimer)
      this.getTimer = setTimeout(() => {
        this.getItemsApi()
      }, 100)
    },
    deleteItemApi (item) {
      const id = item.customer_id
      this.loading = true
      this.axios.delete(`/api/${API_URL}/${id}`)
        .then((response) => {
          this.loading = false
          const index = this.items.indexOf(item)
          this.items.splice(index, 1)
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    deleteItem (item) {
      if (confirm('Вы действительно хотите удалить эту строку?')) {
        this.deleteItemApi(item)
      }
    },
    edit (item) {
      this.customerData = item
      this.editingCustomer = true
    },
    add () {
      this.customerData = {
        company_bik: null,
        company_full_name: null,
        company_inn: null,
        company_kpp: null,
        company_ks: null,
        company_legal_address: null,
        company_ogrn: null,
        company_rs: null,
        company_short_name: null,
        created_at: null,
        customer_id: null,
        customer_number: null,
        customer_type: 1,
        first_name: null,
        last_name: null,
        middle_name: null,
        remark: null,
        snils: null
      }
      this.editingCustomer = true
    },
    edited (customer) {
      if (this.customerData.customer_id != null) {
        Object.assign(this.customerData, customer)
      } else {
        this.items.push(customer)
      }
      this.editingCustomer = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card.customers-card {
    position: unset;
    > .v-btn {
      float: right;
      margin: 8px 16px;
      position: relative;
      z-index: 3;
    }
    .v-data-table {
      position: absolute;
      height: 100%;
      padding-top: 40px;
      right: 0;
      left: 0;
    }
    /deep/ .v-data-table__wrapper {
      max-height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/customers/Customers.vue